import { render, staticRenderFns } from "./VinDate.vue?vue&type=template&id=37b0abb3&scoped=true"
import script from "./VinDate.vue?vue&type=script&lang=js"
export * from "./VinDate.vue?vue&type=script&lang=js"
import style0 from "./VinDate.vue?vue&type=style&index=0&id=37b0abb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b0abb3",
  null
  
)

export default component.exports